import { Box, Button, TextField, Typography } from "@mui/material";
import React, { useEffect, useReducer, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import MessageAlert from "../Common/MessageAlert";
import { subscribeForm } from "../Layout/utils";
import PrimaryModal from "./PrimaryModal";

const NewsletterModal = ({ open, onClose }) => {
  const { t } = useTranslation();
  const formRef = useRef(null);
  const form = subscribeForm;

  const [feedbackMessage, setFeedbackMessage] = useState("");
  const [feedbackSeverity, setFeedbackSeverity] = useState("success");

  useEffect(() => {
    if (open) formRef.current?.focus();
    setFeedbackMessage(""); // Clear message when modal opens
  }, [open]);

  const initialState = { name: "", email: "" };
  const formReducer = (state, action) => {
    switch (action.type) {
      case "SET_NAME":
        return { ...state, name: action.payload };
      case "SET_EMAIL":
        return { ...state, email: action.payload };
      case "RESET":
        return initialState;
      default:
        return state;
    }
  };

  const [formState, dispatch] = useReducer(formReducer, initialState);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append(form.fields.name, formState.name);
    formData.append(form.fields.email, formState.email);

    try {
      await fetch(form.url, {
        method: "POST",
        mode: "no-cors",
        body: formData,
      });

      setFeedbackMessage(t("newsletterModal.success"));
      setFeedbackSeverity("success");
      dispatch({ type: "RESET" });

      setTimeout(onClose, 2000);
    } catch (error) {
      console.error("Error submitting form:", error);
      setFeedbackMessage(t("newsletterModal.error"));
      setFeedbackSeverity("error");
    }
  };

  return (
    <PrimaryModal open={open} handleClose={onClose} title={t("newsletterModal.title")}>
      <Typography sx={{ mb: 2, color: "text.secondary" }}>{t("newsletterModal.subtitle")}</Typography>

      {feedbackMessage && (
        <MessageAlert severity={feedbackSeverity} onClose={() => setFeedbackMessage("")}>
          {feedbackMessage}
        </MessageAlert>
      )}

      <form onSubmit={handleSubmit}>
        <TextField
          label={t("newsletterModal.nameLabel")}
          placeholder={t("newsletterModal.namePlaceholder")}
          value={formState.name}
          onChange={(e) => dispatch({ type: "SET_NAME", payload: e.target.value })}
          required
          fullWidth
          margin="normal"
        />
        <TextField
          label={t("newsletterModal.emailLabel")}
          placeholder={t("newsletterModal.emailPlaceholder")}
          value={formState.email}
          onChange={(e) => dispatch({ type: "SET_EMAIL", payload: e.target.value })}
          required
          fullWidth
          margin="normal"
        />

        <Box sx={{ mt: 2 }}>
          <Button type="submit" variant="contained" color="primary" fullWidth>
            {t("newsletterModal.submitButton")}
          </Button>
        </Box>
      </form>
    </PrimaryModal>
  );
};

export default NewsletterModal;
